import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Channel } from 'src/app/models/channels.inteface';

@Component({
  selector: 'globot-channel-selector',
  templateUrl: './channel-selector.component.html',
  styleUrls: ['./channel-selector.component.scss'],
})
export class ChannelSelectorComponent implements OnInit {
  @Output() channelsChange = new EventEmitter<Channel[]>();

  channels!: Channel[];

  selectedChannels!: Channel[];

  ngOnInit() {
    this.channels = [
      { name: 'Página Web', code: 'WEB' },
      { name: 'Discord', code: 'DISCORD' },
      { name: 'Messenger', code: 'MESSENGER' },
      { name: 'Instagram', code: 'INSTAGRAM' },
      { name: 'Whatsapp', code: 'WHATSAPP' },
    ];
    this.selectedChannels = [...this.channels];
  }
  onChannelsSelect() {
    this.channelsChange.emit(this.selectedChannels);
  }
}
